import {AssetCategoryApiDto} from "../../api/model/rest";
import DictionaryItem from "../dictionary/DictionaryItem";
import JsonConverter from "../../api/helper/JsonConverter";

/**
 * Asset category model.
 */
export default class AssetCategory extends DictionaryItem {
	constructor(public readonly id: string,
		public readonly name: string,
		public readonly disabled: boolean) {
		super(id, name);
	}

	static fromJson(json: AssetCategoryApiDto): AssetCategory {
		return new AssetCategory(json.id, json.name, json.disabled);
	}

	toJson() {
		const json = {
			id: this.id,
			name: this.name,
			disabled: this.disabled
		};
		return JsonConverter.removeEmptyFields(json);
	}

	copy({id = this.id, name = this.name, disabled = this.disabled}) {
		return new AssetCategory(id, name, disabled);
	}
}